angular.module('bizmetryApp').service('DownloadService', function(TelemetryAgentService, $mdToast) {
  this.downloadAgentWithProgress = function(agent) {
    $scope.showDownloadProgress = true;
    $scope.downloadProgress = 0;

    TelemetryAgentService.downloadAgentWithProgress(agent.agentId, function(progress) {
      $scope.$apply(() => {
        $scope.downloadProgress = progress;
      });
    })
    .then(function(data) {
      const buffer = new Uint8Array(data);
      const isZip = (
        buffer[0] === 0x50 &&
        buffer[1] === 0x4B &&
        buffer[2] === 0x03 &&
        buffer[3] === 0x04
      );

      if (!isZip) {
        console.error('Invalid ZIP signature:', buffer.slice(0, 8));
        $scope.showDownloadProgress = false;
        $mdToast.showSimple('Download failed: Invalid ZIP file.');
        return;
      }

      // Descargar el archivo ZIP
      const blob = new Blob([data], { type: 'application/zip' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = agent.agentName + '-config.zip';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      $scope.showDownloadProgress = false; // Finalizar el progreso
      $mdToast.showSimple('Download complete!');
    })
    .catch(function(error) {
      $scope.showDownloadProgress = false;
      $mdToast.showSimple('Download failed: ' + error.message);
    });
  };
});
